/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Unlock_Full_AccessInputs */

const en_common_unlock_full_access = /** @type {(inputs: Common_Unlock_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock Full Access`)
};

const es_common_unlock_full_access = /** @type {(inputs: Common_Unlock_Full_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquea el acceso completo`)
};

/**
* | output |
* | --- |
* | "Unlock Full Access" |
*
* @param {Common_Unlock_Full_AccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_unlock_full_access = /** @type {((inputs?: Common_Unlock_Full_AccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Unlock_Full_AccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_unlock_full_access(inputs)
	return en_common_unlock_full_access(inputs)
});